import {create} from "zustand";
import {DictionariesResponse, IDictionariesState} from "./types";
import {$api} from "shared/api";
import {IDictionary} from "shared/types";
import {serializeParams} from "shared/helpers/converters";

export const useDictionariesStore = create<IDictionariesState>((set, get) => ({
  dictionaries: [],

  isOpenModalAddDictionary: false,
  openAddModal: () => set({ isOpenModalAddDictionary: true }),
  closeAddModal: () => set({ isOpenModalAddDictionary: false }),

  isOpenModalRenameDictionary: false,
  openRenameModal: () => set({ isOpenModalRenameDictionary: true }),
  closeRenameModal: () => set({ isOpenModalRenameDictionary: false }),

  isEditModalOpen: false,
  editOpenId: undefined,
  typeHandlerType: null,

  openEditModal: (id, value) =>
    set({
      isEditModalOpen: true,
      editOpenId: id,
      typeHandlerType: value,
    }),

  closeEditModal: () =>
    set({
      isEditModalOpen: false,
      editOpenId: undefined,
      typeHandlerType: null,
    }),

renameDictionary: async (oldType: string, newType: string) => {
  const dictionaries = get().dictionaries;
  const anyItem = dictionaries.find((d) => d.type === oldType);
  if (!anyItem) return;
  try {
    const body = {
      type: newType,
    };
    const { data: updatedItems } = await $api.patch<IDictionary[]>(
      `/dictionaries/${anyItem.id}/type`,
      body
    );
    set((state) => ({
      dictionaries: state.dictionaries.map((item) => {
        const upd = updatedItems.find((u) => u.id === item.id);
        return upd ? upd : item;
      }),
    }));
  } catch (err) {
    console.error("Ошибка при переименовании словаря", err);
    throw err;
  }
},


  getDictionariesFromServer: async (id, params) => {
    const path = `/dictionaries/`;
    const res = await $api.get<DictionariesResponse>(path, {
      params: {
        apiaryId: id,
        ...params,
      },
      paramsSerializer: { serialize: serializeParams },
    });

    const items: IDictionary[] = res.data ?? [];
    set({ dictionaries: items });
  },

  getDictionaries: () => {
    return get().dictionaries;
  },

  addDictionary: async (params) => {
    try {
      const res = await $api.post<IDictionary>("/dictionaries", params);

      set((state) => ({
        dictionaries: [...state.dictionaries, res.data],
      }));

      return res;
    } catch (error) {
      console.error("Ошибка при добавлении словаря", error);
      throw error;
    }
  },

  updateDictionaryEntry: async (params, openId) => {
    try {
      const res = await $api.put<IDictionary>(
        `/dictionaries/${openId}`,
        params
      );

      set((state) => ({
        dictionaries: state.dictionaries.map((item) =>
          item.id === res.data.id ? res.data : item
        ),
      }));

      return res;
    } catch (error) {
      console.error("Ошибка при обновлении словаря", error);
      throw error;
    }
  },
}));
